/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { recruiterBookingAttendance } from '../../axios/recruiterBookingAttendance'
import type {
	RecruiterBookingAttendanceError,
	RecruiterBookingAttendancePathParams,
	RecruiterBookingAttendanceRequest,
	RecruiterBookingAttendanceResponse,
} from '../../types/RecruiterBookingAttendance'

export const recruiterBookingAttendanceMutationKey = () =>
	[{ url: '/interview-scheduling/bookings/:bookingId/attendance' }] as const

export type RecruiterBookingAttendanceMutationKey = ReturnType<typeof recruiterBookingAttendanceMutationKey>

export type RecruiterBookingAttendanceVariables = {
	bookingId: RecruiterBookingAttendancePathParams['bookingId']
	data: RecruiterBookingAttendanceRequest
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterBookingController.php RecruiterBookingController::attendance */
export function useRecruiterBookingAttendance<TContext = unknown>(
	options?: UseMutationOptions<
		RecruiterBookingAttendanceResponse,
		AxiosError<RecruiterBookingAttendanceError>,
		RecruiterBookingAttendanceVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: recruiterBookingAttendanceMutationKey(),
		mutationFn: ({ bookingId, data }: RecruiterBookingAttendanceVariables) =>
			recruiterBookingAttendance(bookingId, data, config).then(res => res.data),
		...options,
	})
}
